var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertBodySkeletonLoaderWrapper, AlertTitleSkeletonLoaderWrapper, CustomSkeleton } from './subcomponents';
var AlertsSkeletonLoader = function (_a) {
    var _b = _a.titleCount, titleCount = _b === void 0 ? 1 : _b, _c = _a.bodyCount, bodyCount = _c === void 0 ? 3 : _c;
    return (_jsxs(_Fragment, { children: [_jsx(AlertTitleSkeletonLoaderWrapper, __assign({ "data-test": "AlertTitleSkeletonLoaderWrapper" }, { children: _jsx(CustomSkeleton, { duration: 0.5, borderRadius: "0px", marginBottom: "37px", count: titleCount }) })), _jsx(AlertBodySkeletonLoaderWrapper, { children: _jsx(CustomSkeleton, { height: "50px", duration: 0.5, count: bodyCount }) })] }));
};
export default AlertsSkeletonLoader;
